import {request, serviceUrl} from "@/utils/request";

// 告警配置列表分页
export function getPageList(current = null, size = null, spaceId = null, levelId = null
  , accountId = null
  , typeCode = null) {
  return request({
    url: serviceUrl.deviceService + '/alarm/receiver/getList',
    params: {
      current,
      size,
      spaceId,
      levelId,
      accountId,
      typeCode
    }
  })
}

// 获取空间下可授权的组织人员列表
export function getAccountListBySpaceId(spaceId) {
  return request({
    url: serviceUrl.deviceService + '/alarm/receiver/getAccountListBySpaceId',
    params: {
      spaceId
    }
  })
}

// 批量增加告警接收人数据
export function saveReceiver(data) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/receiver/saveReceiver',
    data: data
  })
}

// 修改告警接收人数据
export function updateReceiver(data) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/receiver/updateReceiver',
    data: data
  })
}

// 删除接收人策略
export function deleteById(id) {
  return request({
    method: 'DELETE',
    url: serviceUrl.deviceService + '/alarm/receiver/delete',
    params: {id}
  })
}
